import glo from '../../main'
import { tkParse } from '@moke/vue-tk'

export default {
  className: 'house',
  render: (record) => {
    return `${record.community.name}-${record.building.name}-${record.unit.name}-${record.room.name}`
  },
  search: [
    'community',
    'building',
    'unit',
    'room',
    'isArrears'
  ],
  fields: [
    {
      name: 'community',
      searchKey: ['name'],
      validators: [
        (val) => val ? null : '小区不可为空'
      ]
    },
    {
      name: 'building',
      searchKey: ['name'],
      validators: [
        (val) => val ? null : '楼号不可为空'
      ]
    },
    {
      name: 'unit',
      searchKey: ['name'],
      validators: [
        (val) => val ? null : '单元不可为空'
      ]
    },
    {
      name: 'room',
      searchKey: ['name'],
      validators: [
        (val) => val ? null : '房号不可为空'
      ]
    },
    {
      name: 'area',
      validators: [
        (val) => val ? null : '面积不可为空'
      ]
    },
    {
      name: 'isArrears',
      tooltip: '拖欠开启后，水电费限制将会生效'
    },
    {
      name: 'water'
    },
    {
      name: 'electric'
    }
  ],
  hooks: {
    async beforeUpdate (data) {
      let { data: res } = await tkParse.get('/classes/house', {
        params: {
          where: {
            building: data.data.building,
            community: data.data.community,
            room: data.data.room,
            unit: data.data.unit,
            objectId: {
              $ne: data.objectId
            }
          }
        }
      })
      if (res.results.length) {
        throw Error(`房间已存在`)
      }
    },
    async beforeInsert ({ data }) {
      let { data: res } = await tkParse.get('/classes/house', {
        params: {
          where: {
            building: data.building,
            community: data.community,
            room: data.room,
            unit: data.unit
          }
        }
      })
      if (res.results.length) {
        throw Error(`房间已存在`)
      }
    }
  },
  action: {
    // delete: false,
    download: {
      type: 'list',
      text: '下载模板',
      callback: async function () {
        window.open('https://moke-runji.oss-cn-beijing.aliyuncs.com/3900d57c-5292-4307-8348-f2458227263c.xlsx', '_blank')
      }
    },
    imports: {
      type: 'list',
      icon: 'import',
      text: '导入',
      callback: async function imports ({ vm }) {
        try {
          const excel = await glo.$excel.pick()
          const exceldata = excel.toJson()
          glo.$loading.show()
          for (let i = 0; i < exceldata.Sheet1.length; i++) {
            const element = exceldata.Sheet1[i]
            // 获取对象的key
            const keys = Object.keys(element)
            // 判断两个数组元素是否相同
            const board = ['小区名称', '楼号', '单元', '房号', '面积']
            const isSame = keys.every((item) => board.includes(item))
            if (!isSame) {
              throw new Error()
            }
            if (!(element['小区名称'] && element['楼号'] && element['单元'] && element['房号'] && element['面积'])) { // 是否有必填的
              glo.$loading.hide()
              glo.$notification['error']({
                message: '操作失败',
                description: `第${i + 1}条数据异常`
              })
              if (i > 0) {
                vm.refresh()
              }
              return
            }
            const reside = element['小区名称'].toString()
            const floor = element['楼号'].toString()
            const unit = element['单元'].toString()
            const room = element['房号'].toString()
            const area = element['面积'].toString()
            console.log('area', area)
            const res = await Promise.all([
              tkParse.get(`/classes/residentialQuarters`, {
                params: {
                  where: {
                    name: reside
                  }
                }
              }),
              tkParse.get(`/classes/floor`, {
                params: {
                  where: {
                    name: floor
                  }
                }
              }),
              tkParse.get(`/classes/unit`, {
                params: {
                  where: {
                    name: unit
                  }
                }
              }),
              tkParse.get(`/classes/roomNumber`, {
                params: {
                  where: {
                    name: room
                  }
                }
              })
            ])
            let resideId, floorId, unitId, roomId
            if (res[0].data.results.length > 0) {
              resideId = res[0].data.results[0].objectId
            }
            if (res[1].data.results.length > 0) {
              floorId = res[1].data.results[0].objectId
            }
            if (res[2].data.results.length > 0) {
              unitId = res[2].data.results[0].objectId
            }
            if (res[3].data.results.length > 0) {
              roomId = res[3].data.results[0].objectId
            }
            console.log(resideId, floorId, unitId, roomId)
            if (resideId && floorId && unitId && roomId) {
              const res = await tkParse.get(`/classes/house`, {
                params: {
                  where: {
                    community: resideId,
                    building: floorId,
                    unit: unitId,
                    room: roomId
                  }
                }
              })
              if (res.data.results.length === 0 && area && Number(area)) {
                await tkParse.post(`/classes/house`, {
                  community: resideId,
                  building: floorId,
                  unit: unitId,
                  room: roomId,
                  area: Number(area)
                })
              } else { // 填写数据的正确性
                glo.$loading.hide()
                glo.$notification['error']({
                  message: '操作失败',
                  description: `第${i + 1}条数据异常`
                })
                if (i > 0) {
                  vm.refresh()
                }
                return
              }
            } else { // 填写数据的正确性
              glo.$loading.hide()
              glo.$notification['error']({
                message: '操作失败',
                description: `第${i + 1}条数据异常`
              })
              if (i > 0) {
                vm.refresh()
              }
              return
            }
          }
          glo.$loading.hide()
          glo.$notification['success']({
            message: '操作成功',
            description: '数据已导入'
          })
          vm.refresh()
        } catch (e) {
          glo.$loading.hide()
          glo.$notification['error']({
            message: '操作失败',
            description: '数据格式错误'
          })
        }
      }
    }
  }
}
